import { PopoverTrigger, PopoverContent, PopoverBody, useDisclosure, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import type { FormattedData } from './types';

import Popover from 'ui/shared/chakra/Popover';

import TokenSelectButton from './TokenSelectButton';
import TokenSelectMenu from './TokenSelectMenu';
import useTokenSelect from './useTokenSelect';

interface Props {
  data: FormattedData;
  isLoading: boolean;
}

const TokenSelectDesktop = ({ data, isLoading }: Props) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const popoverBg = useColorModeValue('#FFFFFF', '#111111');
  const popoverBorder = useColorModeValue('#E9ECEF', '#222222');

  const result = useTokenSelect(data);

  return (
    <Popover isOpen={ isOpen } onClose={ onClose } placement="bottom-start" isLazy>
      <PopoverTrigger>
        <TokenSelectButton isOpen={ isOpen } onClick={ onToggle } data={ result.data } isLoading={ isLoading }/>
      </PopoverTrigger>
      <PopoverContent w="355px" maxH="450px" overflowY="scroll" bg={ popoverBg } borderColor={ popoverBorder }>
        <PopoverBody px={ 4 } py={ 6 } boxShadow="2xl" >
          <TokenSelectMenu { ...result }/>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default React.memo(TokenSelectDesktop);
